import axios from 'axios'
import $http from '@/libs/axios'
import { DOMAIN_SEARCH_API } from '@/constants/config'

class BranchAPIs {
  static async update(step: 'basic' | 'languages' | 'social' | 'address' | '', branchId: number, payload: any) {
    return (await $http.put(`/branches/update${step ? `-${step}` : ''}/${branchId}`, payload)).data
  }

  static async updateWpNumber(payload: any) {
    return (await $http.post('/branches/wp-number', payload)).data
  }

  public static async GetBranchSettings(branchId: number) {
    return (await $http.get(`/branches/settings/${branchId}`)).data.branch
  }

  public static async GetBranchDrivers(branchId: number) {
    return (await $http.get(`/branches/settings/${branchId}`)).data.branch
  }

  public static async getShifts(branchId: number) {
    return (await $http.get(`/branches/shifts/${branchId}`)).data
  }

  public static async updateShifts(branchId: number, payload: any) {
    return (await $http.put(`/branches/shifts/${branchId}`, payload)).data
  }

  public static async getOrderCapacities(branchId: number) {
    return (await $http.get(`/branches/order-capacity/${branchId}`)).data
  }

  public static async updateOrderCapacity(branchId: number, payload: any) {
    return (await $http.put(`/branches/order-capacity/${branchId}`, payload)).data
  }

  public static async updateMenuWidget(branchId: number, payload: any) {
    return (await $http.put(`/branches/widget/${branchId}`, payload)).data
  }

  public static async getMenuWidget(branchId: number) {
    return (await $http.get(`/branches/widget/${branchId}`)).data
  }

  public static async sendWidgetEmail(payload: any) {
    return (await $http.post('/branches/widget-email', payload)).data
  }

  public static async updateSubDomain(payload: any) {
    return (await $http.put('/branches/subdomain', payload)).data
  }

  public static async checkDomain(domain: any) {
    return (await axios.get(`${DOMAIN_SEARCH_API}/query/${domain}`)).data
  }

  public static async getDomainSetting(branchId: number) {
    return (await $http.get(`/branches/domain/settings/${branchId}`)).data
  }

  public static async updateDomain(payload: any) {
    return (await $http.put('/branches/domain', payload)).data
  }

  public static async create(action: 'create' | 'clone', branchId?: number) {
    return (await $http.post('/branches/add', { action, from: branchId })).data
  }

  public static async delete(branchId: number, payload: any) {
    return (await $http.post(`/branches/delete/${branchId}`, payload)).data
  }

  public static async updateSettings($branchId: number, payload: any) {
    return (await $http.put(`/branches/update-setting/${$branchId}`, payload)).data
  }

  public static async updateDeliveryShipping($branchId: number, payload: any) {
    return (await $http.post(`/branches/delivery-shipping/${$branchId}`, payload)).data
  }

  public static async copyDeliveryShipping($branchId: number, payload: any) {
    return (await $http.post(`/branches/copy-delivery-shipping/${$branchId}`, payload)).data
  }

  public static async getDeliveryShippingSetting(branchId: number) {
    return (await $http.get(`/branches/delivery-shipping-settings/${branchId}`)).data
  }
}

export default BranchAPIs
